import React from "react";
import { SvgIcon, SvgIconProps } from "@origin-digital/ods-icons";

export const IconInternetLocal = (props: SvgIconProps) => (
  <SvgIcon
    titleAccess="Internet request"
    color="neutral"
    viewBox="8 12 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.0016 30.1398C19.0058 30.1398 18.2016 30.944 18.2016 31.9398C18.2016 32.9356 19.0058 33.7398 20.0016 33.7398C20.9974 33.7398 21.8016 32.9356 21.8016 31.9398C21.8016 30.944 20.9974 30.1398 20.0016 30.1398ZM16.7016 31.9398C16.7016 30.1156 18.1774 28.6398 20.0016 28.6398C21.8258 28.6398 23.3016 30.1156 23.3016 31.9398C23.3016 33.764 21.8258 35.2398 20.0016 35.2398C18.1774 35.2398 16.7016 33.764 16.7016 31.9398Z"
      fill="#505050"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.0016 25.0497C17.621 25.0497 15.5196 26.2573 14.2833 28.0893C14.0515 28.4326 13.5854 28.5231 13.242 28.2914C12.8987 28.0597 12.8082 27.5935 13.0399 27.2502C14.5435 25.0222 17.1021 23.5497 20.0016 23.5497C22.8987 23.5497 25.4168 24.99 26.9213 27.1973C27.1546 27.5396 27.0663 28.0062 26.724 28.2395C26.3817 28.4728 25.9151 28.3844 25.6818 28.0422C24.4463 26.2295 22.3845 25.0497 20.0016 25.0497Z"
      fill="#505050"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.0016 21.6498C16.6939 21.6498 13.7491 23.2141 11.8647 25.6488C11.6112 25.9764 11.1402 26.0364 10.8126 25.7829C10.485 25.5294 10.425 25.0583 10.6785 24.7307C12.8342 21.9454 16.2093 20.1498 20.0016 20.1498C23.7939 20.1498 27.1691 21.9454 29.3247 24.7307C29.5783 25.0583 29.5182 25.5294 29.1907 25.7829C28.8631 26.0364 28.392 25.9764 28.1385 25.6488C26.2542 23.2141 23.3093 21.6498 20.0016 21.6498Z"
      fill="#505050"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.0016 18.2598C15.7453 18.2598 11.9444 20.2019 9.43069 23.2564C9.16747 23.5762 8.69482 23.6221 8.37499 23.3589C8.05516 23.0957 8.00927 22.623 8.27248 22.3032C11.0588 18.9176 15.2778 16.7598 20.0016 16.7598C24.7246 16.7598 28.9335 18.9069 31.72 22.2823C31.9837 22.6017 31.9385 23.0744 31.6191 23.3381C31.2996 23.6018 30.8269 23.5567 30.5632 23.2372C28.0497 20.1926 24.2586 18.2598 20.0016 18.2598Z"
      fill="#505050"
    />
  </SvgIcon>
);
